import { render } from "./ModalPrepareReceipt.vue?vue&type=template&id=4c12a55e"
import script from "./ModalPrepareReceipt.vue?vue&type=script&lang=js"
export * from "./ModalPrepareReceipt.vue?vue&type=script&lang=js"

import "./ModalPrepareReceipt.vue?vue&type=style&index=0&id=4c12a55e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__